import { render, staticRenderFns } from "./driverWorkStatus.vue?vue&type=template&id=88555862&scoped=true&"
import script from "./driverWorkStatus.vue?vue&type=script&lang=js&"
export * from "./driverWorkStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88555862",
  null
  
)

export default component.exports